<footer>
    <p [innerHTML]="'COMMON.COPYRIGHT' | translate: {year: year}"></p>
</footer>